// eslint-disable-next-line max-classes-per-file
import lcrRequest from '../lcrRequest';

export class BettingSuggestionsAPI {
  constructor(path, options) {
    const { matchId, isOperator, language } = options;

    this.url = isOperator
      ? `${path}&match_id=${matchId}&lang=${language}`
      : path;
    this.matchId = options.matchId;
  }

  get() {
    return lcrRequest
      .get(this.url)
      .then(data => {
        if (!data || (data && data.error)) {
          throw data;
        }

        return data;
      }).catch(e => {
        throw new Error(`Betting Suggestions API Request error: ${e}`);
      });
  }
}

export class BettingSuggestionsEventsRequest extends BettingSuggestionsAPI {
  constructor(matchId, isOperator = false, alias, language) {
    super(`/api/betting-suggestion?alias=${alias}`, {
      matchId, isOperator, alias, language,
    });
  }
}
